import { Component, ElementRef } from '@angular/core';
import { LayoutService } from '../../../services/layout/app.layout.service';
import { version } from '../../../../../package.json';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
	appVersion = version;

	constructor(
		public layoutService: LayoutService,
		public el: ElementRef
	) {}
}
